import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { QueryClient, QueryClientProvider } from "react-query";
import { AppContextProvider } from "./contexts/AppContext";
import { SearchContextProvider } from "./contexts/SearchContext";
import { HotelContextProvider } from "./contexts/HotelContext";
// import Snowfall from "react-snowfall";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0, // Will not retry failed requests by default
    },
  },
});

const rootElement = document.getElementById("root");
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppContextProvider>
          <SearchContextProvider>
            <HotelContextProvider>
              {/* <div className="relative">
                <div className="snowfall">
                  <Snowfall snowflakeCount={100} speed={[0.2, 1]} color="#ffffff"/>
                </div> */}
                <App />
              {/* </div> */}
            </HotelContextProvider>
          </SearchContextProvider>
        </AppContextProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}
